import StimulusCheckboxSelectAll from "stimulus-checkbox-select-all";

export default class extends StimulusCheckboxSelectAll {

    static targets = ['checkboxAll', 'checkbox', 'totalCounter', 'checkedCounter']

    connect() {
        super.connect();
    }

    toggle(e) {
        super.toggle(e);
        this.refreshCounters();
    }

    refresh() {
        super.refresh();
        this.refreshCounters();
    }

    refreshCounters() {
        if (this.hasCheckedCounterTarget) {
            this.checkedCounterTarget.innerHTML = this.checked.length;
        }
        if (this.hasTotalCounterTarget) {
            this.totalCounterTarget.innerHTML = this.checkboxTargets.length;
        }
    }
}